module.exports = __webpack_public_path__ + "img/__icon_CYSTERNA_PALIWOWA.60707ba2.svg";